import { PardotRuleReferencesTab } from '@periscopes/general/pardot-rules';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeBodyComponent } from '@periscopes/types';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { PardotObjectEmailTab, PardotObjectEmailTemplateTab, PardotObjectFieldsTab, PardotObjectFormTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';

export const PardotObjectScope: PeriscopeBodyComponent = ({ data, index }) => {
	const { sonarObjectId, relatedCounts = {} } = data;

	return (
		<PeriscopeMenuTabs>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotField ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.FIELDS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.FIELDS }>
				<PardotObjectFieldsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotForm ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.PARDOT_FORMS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.PARDOT_FORMS }>
				<PardotObjectFormTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotEmailTemplate ?? 0 ] }
				key={ PERISCOPE_TAB_TYPES.PARDOT_EMAIL_TEMPLATES }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.PARDOT_EMAIL_TEMPLATES }>
				<PardotObjectEmailTemplateTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotEmail ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.PARDOT_EMAILS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.PARDOT_EMAILS }>
				<PardotObjectEmailTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts.pardotAutomationRuleReference ?? 0 }
				key={ PERISCOPE_TAB_TYPES.RULE_REFERENCES }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.RULE_REFERENCES }>
				<PardotRuleReferencesTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
		</PeriscopeMenuTabs>
	);
};
